import React, {  ChangeEvent, useEffect, useState } from 'react';
import {  Box, Card, Grid, Table, TableBody, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { getLeaveHistory } from 'src/services/leaveService';
import { makeStyles } from '@material-ui/core/styles';
import {  useParams } from 'react-router-dom';

const applyPagination = (
    Leaves: any[],
    page: number,
    limit: number
  ): any[] => {
    return Leaves.slice(page * limit, page * limit + limit);
  };



const validateLeaveStatusColor = (status) => {
    if (
      status === 'APPROVED' ||
      status === 'RM_APPROVED' ||
      status === 'HR_APPROVED'
    ) {
      return '#00d688';
    } else if (status === 'HR_REJECTED' || status === 'RM_REJECTED') {
      return '#FF1943';
    } else if (status === 'PENDING') {
      return '#FFA319';
    } else if (status === 'CANCELLATION_REQUESTED') {
      return '#9C27B0';
    } else if (status === 'CANCELLATION_REJECTED') {
      return '#E65100';
    } else if (status === 'CANCELLED') {
      return '#3376c9';
    }
  };

  const validateLeaveStatus = (status, hrApproved) => {
    if (
      status === 'APPROVED' ||
      status === 'HR_APPROVED' ||
      (status === 'RM_APPROVED' && !hrApproved)
    ) {
      return 'Approved';
    } else if (status === 'RM_APPROVED' && hrApproved) {
      return 'Approved by RM';
    } else if (status === 'HR_REJECTED') {
      return 'Rejected by HR';
    } else if (status === 'RM_REJECTED') {
      return 'Rejected';
    } else if (status === 'PENDING') {
      return 'Pending';
    } else if (status === 'CANCELLATION_REQUESTED') {
      return 'Cancellation Requested';
    } else if (status === 'CANCELLATION_REJECTED') {
      return 'Cancellation Rejected';
    } else if (status === 'CANCELLED') {
      return 'Cancelled';
    }
  };

const LeaveHistory = () => {

    const dispatch = useDispatch();
    const CustomTableRow = withStyles({
        root: {
          background: '#BACEE533 !important',
          height: '3.5rem',
          width: '4.2rem'
        }
      })(TableRow);

    const CustomTableColumn = withStyles({
        root: {
            backgroundColor: '#BACEE533 !important',
        }
    })(Card);
    


    const useStyles = makeStyles({
        root: {
            textAlign: 'center'
        }
    });
    const classes = useStyles();


    const [expand, setExpand] = useState(false);
    const [expandedCode, setExpandedCode] = useState('');

    const expandTable = (code: string) => {
        setExpand(!expand);
        setPage(0);
        setLimit(10)
        if (expandedCode !== code) {
            setExpand(true);
        }
        setExpandedCode(code);
    };



    function getLeavesForYear(year,data) {
        const yearData = data.find(item => item.year === year);
        return yearData ? yearData.leaves : [];
      }

    //----------------------------
    const [leaveList, setLeaveList] = useState<any>([]);
    const { employeeId } = useParams();

    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);

    const paginatedLeaves = applyPagination( getLeavesForYear(expandedCode, leaveList), page, limit);
   
    useEffect(() => {
        leavesHistory(employeeId);

    }, [employeeId]);

    const groupLeavesByYear = (leaves) => {
        const groupedLeaves = {};
        leaves.forEach(leave => {
            const fromYear = new Date(leave.fromDate).getFullYear().toString();
            const toYear = new Date(leave.toDate).getFullYear().toString();
            const yearRange = fromYear === toYear ? fromYear : `${fromYear}-${toYear}`;
    
            if (!groupedLeaves[yearRange]) {
                groupedLeaves[yearRange] = [];
            }
            groupedLeaves[yearRange].push(leave);
        });
    
        // Convert groupedLeaves object into an array of objects with 'year' attribute
        const result = [];
        for (const year in groupedLeaves) {
            result.push({ year, leaves: groupedLeaves[year] });
        }
        result.sort((a, b) => parseInt(b.year) - parseInt(a.year));
        return result;
    };


    const leavesHistory = (employeeId: string) => {
        dispatch(AppActions.showLoader());
        getLeaveHistory(employeeId)
            .then((res) => {
                if (res.data) {
                    //reorder by latest from date
                    const reorderByFormDate = res.data?.data.sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
                    setLeaveList(groupLeavesByYear(reorderByFormDate));
                }
                dispatch(AppActions.hideLoader());
            })
            .catch((e) => {
                dispatch(AppActions.hideLoader());
            });
    };

    const handlePageChange = (event: any, newPage: number): void => {
        setPage(newPage);
      };

      const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setLimit(parseInt(event.target.value));
      };

    return (

        <Grid sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
            {leaveList &&
                leaveList?.length > 0 &&
                leaveList?.map((year, i) => (
                    <Grid key={i}>
                        <CustomTableColumn
                            style={{
                                marginTop: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '1rem',
                                justifyContent: "space-between",
                                boxShadow: `${expand &&
                                    expandedCode === year.year &&
                                    'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px'}`
                            }}
                        >
                            <Typography style={{ fontSize: '11px', width: '25rem' }}>
                                {year.year}
                            </Typography>
                            {expand && expandedCode === year.year ? (
                                <ExpandLessIcon
                                    id={"btn-expandTable-lessIcon-" + i}
                                    onClick={() => expandTable(year.year)}
                                    style={{
                                        fontSize: '27px',
                                        cursor: 'pointer'
                                    }}
                                />
                            ) : (
                                <ExpandMoreIcon
                                    id={"btn-expandTable-moreIcon-" + i}
                                    onClick={() => expandTable(year.year)}
                                    style={{
                                        fontSize: '27px',
                                        cursor: 'pointer'
                                    }}
                                />
                            )}
                        </CustomTableColumn>
                        {expand && expandedCode === year.year && (
                            <TableContainer className="tableContainer">
                                <Table size="small">
                                    <TableHead>
                                        <CustomTableRow>
                                            <TableHeaderCell content="From" smallFont />
                                            <TableHeaderCell content="To" smallFont />
                                            <TableHeaderCell content="Days Count" smallFont />
                                            <TableHeaderCell content="Full Day/Half Day" smallFont />
                                            <TableHeaderCell content="Leave Type" smallFont />
                                            <TableHeaderCell content="Status" smallFont />
                                        </CustomTableRow>
                                    </TableHead>
                                    <TableBody className={classes.root}>
                                        {paginatedLeaves &&
                                            paginatedLeaves.map((leave) => {
                                                return (
                                                    <TableRow hover>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {leave.fromDate}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                color="text.primary"
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {leave.toDate}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                color="text.primary"
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {leave.daysCount}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                color="text.primary"
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {leave.typeName === 'Short Leave'
                                                                    ? 'N/A'
                                                                    : leave.dateType
                                                                        ? 'Full Day'
                                                                        : 'Half Day'}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{ fontSize: '11px' }}
                                                                color="text.primary"
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {leave.isEligible
                                                                    ? 'Lieu Leave Eligibility'
                                                                    : leave.typeName}
                                                            </Typography>
                                                        </TableColumnCell>
                                                        <TableColumnCell>
                                                            <Typography
                                                                paddingBottom="0.25rem"
                                                                paddingTop="0.5rem"
                                                                variant="body2"
                                                                style={{
                                                                    fontSize: '11px',
                                                                    color: validateLeaveStatusColor(leave.status)
                                                                }}
                                                                color="text.primary"
                                                                gutterBottom
                                                                noWrap
                                                            >
                                                                {validateLeaveStatus(
                                                                    leave.status,
                                                                    leave.hrApproved
                                                                )}
                                                            </Typography>
                                                        </TableColumnCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                                <Box p={2}>
                            <TablePagination
                                sx={{
                                    fontSize: '12px',
                                    '.MuiTablePagination-displayedRows': {
                                        fontSize: '12px'
                                    },
                                    '.MuiTablePagination-selectLabel': {
                                        fontSize: '12px'
                                    }
                                }}
                                component="div"
                                count={year?.leaves?.length}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            />
                        </Box>
                            </TableContainer>
                        )}
                        
                    </Grid>
                ))}
            {leaveList?.length === 0 && (
                <Typography
                    style={{
                        fontSize: '15px',
                        fontWeight: 'bold',
                        margin: '1rem',
                        textAlign: 'center'
                    }}
                    variant="body2"
                >
                    No Records Found
                </Typography>
            )}
        </Grid>

    );
};

export default LeaveHistory;
